import { deserialize, inheritSerialization } from 'cerialize'
import { ReceivingFileModel } from 'Models'

@inheritSerialization(ReceivingFileModel)
export class TrustModel extends ReceivingFileModel {
	@deserialize public id: number
	@deserialize public start_date: string
	@deserialize public end_date: string
}
